<template>
	<div class="ls-flex ls-al-center ls-jc-center p-b-40">
		<div class="ls-flex ls-al-center ls-jc-center">
			<div class="ls-flex-flex">
				
			</div>
			<div class="ls-flex">
				<div class="page-item ls-flex ls-al-center ls-jc-center" @click="pageChange('sub')">
					<
				</div>
				<div class="page-item ls-flex ls-al-center ls-jc-center" v-show="page.pageNum > 4">
					...
				</div>
				<div @click="goto(ix + 1)" v-show="ix < 5 && page.pageNum - 4 < 1" class="page-item ls-flex ls-al-center ls-jc-center" :class="[ix + 1 == page.pageNum ? 'page_active' : '']"   v-for="(im,ix) in page.pageTotal" >
					{{ix + 1}}
				</div>
				<div class="page-item ls-flex ls-al-center ls-jc-center" @click="goto(page.pageNum - 4)"   v-show="page.pageNum > 4 && page.pageNum > page.pageTotal - 2 && page.pageNum != page.pageTotal - 1">
					{{page.pageNum - 4}}
				</div>
				<div class="page-item ls-flex ls-al-center ls-jc-center" @click="goto(page.pageNum - 3)"   v-show="page.pageNum > 4 && page.pageNum > page.pageTotal - 2">
					{{page.pageNum - 3}}
				</div>
				<div class="page-item ls-flex ls-al-center ls-jc-center" @click="goto(page.pageNum - 2)"   v-show="page.pageNum > 4">
					{{page.pageNum - 2}}
				</div>
				<div class="page-item ls-flex ls-al-center ls-jc-center" @click="goto(page.pageNum - 1)"   v-show="page.pageNum > 4">
					{{page.pageNum - 1}}
				</div>
				<div class="page-item ls-flex ls-al-center ls-jc-center page_active" @click="goto(page.pageNum)"   v-show="page.pageNum > 4">
					{{page.pageNum}}
				</div>
				<div class="page-item ls-flex ls-al-center ls-jc-center" @click="goto(page.pageNum + 1)"   v-show="page.pageNum > 4 && page.pageNum < page.pageTotal">
					{{page.pageNum + 1}}
				</div>
				<div class="page-item ls-flex ls-al-center ls-jc-center" @click="goto(page.pageNum + 2)"   v-show="page.pageNum > 4 && page.pageNum < page.pageTotal - 1">
					{{page.pageNum + 2}}
				</div>
				<div class="page-item ls-flex ls-al-center ls-jc-center"   v-show="page.pageTotal > 5 && page.pageNum < page.pageTotal - 2">
					...
				</div>
				<div class="page-item ls-flex ls-al-center ls-jc-center"   @click="pageChange('add')">
					>
				</div>
			</div>
			<div class="ls-flex-flex">
				
			</div>
		</div>
	</div>
</template>

<script>
export default {
	//当前页  总长度  回调函数  页面长度
	props: ["start", "length", "change", "pageSize","type"],
	data() {
		return {
			page: {
				pageNum: this.start,
				// pageSize: 13,
				pageTotal: this.length,
				// rowTotal: 10,
			},
		}
	},
	methods: {
		goto(ix){
			let _self = this;
			_self.page.pageNum = ix;
			_self.change(_self.page.pageNum);
		},
		pageChange(key){
			let _self = this;
			if(key == 'sub'){
				if(_self.page.pageNum > 1){
					_self.page.pageNum--;
				}else{
					_self.$message('已经是第一页');
					return;
				}
			}else if(key == 'add'){
				if(_self.page.pageNum < _self.page.pageTotal){
					_self.page.pageNum++;
				}else{
					_self.$message('已经是最后一页');
					return;
				}
			}
			_self.change(_self.page.pageNum);
		},
	},
	// 监听父组件传递的参数变化
	watch: {
		start(curVal,oldVal){
			if(curVal){
				this.page.pageNum = curVal;
			}
		},
		length(curVal,oldVal){
			if(curVal){
				this.page.pageTotal = curVal;
			}
		}
	},
}
</script>

<style lang="scss">
	.page-item{
		width: 35px;
		height: 35px;
		background: #F4F4F4;
		border-radius: 50%;
		color: #333;
		font-size: 20px;
		margin-left: 13px;
		cursor: pointer;
	}
	.page_active{
		background: #3546A0 !important;
		color: #fefefe !important;
	}
</style>